import React,{ useState,useEffect} from 'react'
import axios from "axios"
// import BTCRate from "../../components/BTCRate"
import useFetch from "../../hooks/useFetch"
// import { CryptoItems } from "../Trade/CryptoItems";
import { useSnackbar } from "notistack"
import "./styles.css"

function HomeCalculation() {
  const { enqueueSnackbar } = useSnackbar();
  const [amount, setAmount] = useState("");
  const [checked, setChecked] = useState(false);
  const [isSell, setIsSell] = useState(true);
  const [apiValue, setApiValue] = useState(0);
  const [usd, setUsd] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("BTC");
  const [totalAmount,setTotalAmount] = useState(0);
  const [buyRate,setBuyRate] = useState(0)
  const {response:list} = useFetch()

  const [buyingRate, setBuyingRate] = useState("");

  useEffect(() => {
    if (list.length > 0) {
      setBuyingRate(list.filter((el) => el.Crypto === selectedCurrency)[0].Sell);
      
    }
  }, [list,selectedCurrency]);
// eslint-disable-next-line
  String.prototype.removeCharAt = function (i) {
    var tmp = this.split(''); 
    tmp.splice(i - 1 , 1);
    return tmp.join('');
}
  const formatAmount = price =>{
    let increasedPrice;
    let newIncreasedPrice;
    if(price.toString().length ===4 ){

            increasedPrice = price.toString().replace(/(\d{1})/g, "$1,").replace(/(^\s+|\s+$)/, "")
            newIncreasedPrice = increasedPrice.removeCharAt(4).removeCharAt(5).removeCharAt(6)
        }
    else if(price.toString().length ===5 ){

        increasedPrice = price.toString().replace(/(\d{2})/g, "$1,").replace(/(^\s+|\s+$)/, "")
        newIncreasedPrice = increasedPrice.removeCharAt(6)
    }
    else if(price.toString().length === 6 ){
        increasedPrice = price.toString().replace(/(\d{3})/g, "$1,").replace(/(^\s+|\s+$)/, "")
        newIncreasedPrice = increasedPrice.removeCharAt(8)
    }
    else  if(price.toString().length === 7 ){
        increasedPrice = price.toString().replace(/(\d{1})/g, "$1,").replace(/(^\s+|\s+$)/, "")
        newIncreasedPrice = increasedPrice.removeCharAt(4).removeCharAt(5).removeCharAt(8).removeCharAt(9).removeCharAt(10)
    }
    else{
      newIncreasedPrice= price
    }
    return newIncreasedPrice
}
  useEffect(() => {
  
    const getPrice =async ()=>{
      try{
        let res= await axios.get(`https://min-api.cryptocompare.com/data/pricemulti?fsyms=${selectedCurrency}&tsyms=USD`)
        const {data} = res
       if (data) setApiValue(data[selectedCurrency]["USD"]);
     }
     catch(_er){
      enqueueSnackbar("No internet connection", {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      })
    }
   }
   if(selectedCurrency)getPrice()
 }, [enqueueSnackbar,selectedCurrency]);

 useEffect(() => {
      const real = list.filter((el)=>el.Crypto === selectedCurrency)
      if(real.length >0)
      if(!isNaN(real[0][(isSell?"Sell":"Buy")])){
        setBuyRate(real[0].Sell)
      }  
  }, [list,selectedCurrency,isSell]);
  const handleUsdChange = e=>{
    if(!isNaN(e.target.value)){
      let amountss =checked ? (e.target.value/(apiValue*buyRate)).toString().slice(0,8) :(e.target.value/apiValue).toString().slice(0,8)
    
      // let value = parseInt(amountss)
      setAmount(amountss)
      setUsd(e.target.value)
      setTotalAmount(e.target.value)
  }
  }
  const onAmountChange = (e)=>{
    if(!isNaN(e.target.value)){
      let amountss = checked ? Math.round((e.target.value*apiValue)*buyRate) : Math.round(e.target.value*apiValue)
      let value = parseInt(amountss)
      setAmount(e.target.value)
      setUsd(amountss)
      setTotalAmount(value)
  }
}
const onSwitch =(e)=>{
    if(e.target.value === "NGN")
    setChecked(true)
    if(e.target.value === "NGN"){
      setTotalAmount(prev =>  Math.round(prev*buyRate))
      setUsd(prev => prev*buyRate)
    }
    else{
      setChecked(false)
      setTotalAmount(prev => Math.round(prev/buyRate))
      setUsd(prev => Math.round(prev/buyRate))
    }
}
    return (
        <div className="m-auto bts-settings-wrapper">
                <div className="d-flex">
                  <p onClick={()=>{
                      setIsSell(true)
                      if(isSell === false){
                        setUsd("")
                        setAmount("")
                        setTotalAmount("")
                      }
                      }} className={`med cursor blueText cal-bor mr-3 b7 ${isSell?"cal-active":""}`}>Sell</p>
                  <p onClick={()=>{
                      setIsSell(false)
                      if(isSell === true){
                        setUsd("")
                        setAmount("")
                        setTotalAmount("")
                      }
                      }} className={`med cursor blueText cal-bor b7 ${!isSell?"cal-active":""}`}>Buy</p>
                </div>
                 
                  <form action="">
                  <div className="row align-items-baseline">  
                 
                <div className="col-md-6 position-relative">
                      <input type="text" maxLength={11} className="cal-pad-left my-3" onChange={handleUsdChange} value={usd}/>
                      <div className="d-flex cal-sel" style={{backgroundColor: "#EDF1F9"}}>
                        <select onChange={(e)=>onSwitch(e)} className="p-0 bg-white trans-select">
                        <option value="USD">USD</option>
                        <option value="NGN">NGN</option>
                        </select>
                    </div>
                        {/* <span className="smallText blueText b5 cal-bottom position-absolute input-details">{checked?`N${formatAmount(totalAmount)}`:`$${formatAmount(totalAmount)}`}</span> */}
                </div>
                <div className="col-md-6 position-relative">
                      <input type="text" className="cal-pad-left" onChange={onAmountChange} value={amount}/>
                        
                        <div className="d-flex cal-sel2" style={{backgroundColor: "#EDF1F9"}}>
                        <select onChange={(e)=>{
                            setUsd("")
                            setAmount("")
                            setTotalAmount("")
                            setSelectedCurrency(e.target.value)}}  className="p-0 bg-white trans-select">
                        <option value="BTC">BTC</option>
                        <option value="ETH">ETH</option>
                        <option value="LTC">LTC</option>
                        <option value="USDT">USDT</option>
                        </select>
                    </div>
                    {/* <span className="smallText lightBlue b5 position-absolute  input-details">{amount}</span> */}
                </div>
                </div>
                {isSell && <span className="smallText lightBlue b5">
              We Buy ₦{buyingRate}/$
            </span>}
                <div className="justify-content-between py-2 my-3 px-2 border-rad bts-coin-rates d-flex whiteText">
                  <span className="lightText">We'll pay you</span>
                  <span className="blueText font-weight-bold">{checked?`N${formatAmount(totalAmount)}`:`N${formatAmount(Math.round(totalAmount*buyRate))}`}</span>
                </div>
            </form>
                 
          </div>
                
    )
}

export default HomeCalculation
